import { useClientPortalInternalData } from '../../hooks'

export const useOtherCriticalDates = () => {
  const { dataClientPortalInternal, navigateToCaseDetail } = useClientPortalInternalData()

  const scheduledAlertsData = dataClientPortalInternal?.alertSchedule

  const noData = !scheduledAlertsData || scheduledAlertsData.length === 0

  return { noData, scheduledAlertsData, navigateToCaseDetail }
}
